import { ChangeDetectionStrategy, Component, computed, signal, viewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared-features/buttons/button/button.component';
import { AppRoutes } from '@shared/enums';
import { GeneralHelper } from '@shared/helpers';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
    selector: 'new-order-button',
    standalone: true,
    imports: [OverlayPanelModule, TranslateModule, ButtonComponent],
    templateUrl: './new-order-button.component.html',
    styleUrl: './new-order-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewOrderButtonComponent {
    startOrderOverlay = viewChild<OverlayPanel | null>('op');
    appRoutes = AppRoutes;

    readonly geneticMonitoringUrl = environment.geneticMonitoring + '/Samples';
    readonly microbiomeUrl = environment.microbiome + '/Add';

    private routerUrl = signal<string>(this.router.url);
    private isMenuJustOpened = signal<boolean>(false);

    isOrderSetupActive = computed(() => {
        const urlWithoutQueryParams = GeneralHelper.getUrlWithoutQueryParams(this.routerUrl().toLowerCase());
        
        if(urlWithoutQueryParams === '/') return false;

        if (AppRoutes.ORDER_SETUP_STRAIN_SELECTION.valueOf().indexOf(urlWithoutQueryParams) > -1) return true;
        if (AppRoutes.ORDER_SETUP_SAMPLE_ENTRY.valueOf().indexOf(urlWithoutQueryParams) > -1) return true;
        if (AppRoutes.ORDER_SETUP_FINALIZE_ORDER.valueOf().indexOf(urlWithoutQueryParams) > -1) return true;

        return false;
    });

    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.routerUrl.set(event.url);
            }
        });
    }

    onMenuShow(): void {
        this.isMenuJustOpened.set(true);

        setTimeout(() => {
            this.isMenuJustOpened.set(false);
        }, 200);
    }

    closeMenu(): void {
        this.startOrderOverlay()?.hide();
        document.getElementById('start-new-order-btn')?.focus();
        (document.getElementById('start-new-order-btn')?.firstChild as HTMLElement)?.focus();
    }

    handleGenotypingClick(event: Event): void {
        if (this.isMenuJustOpened()) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (this.isOrderSetupActive()) {
            event.preventDefault();
            return;
        }
        this.startOrderOverlay()?.toggle(false);
        this.router.navigate([this.appRoutes.ORDER_SETUP_STRAIN_SELECTION]);
    }

    handleGeneticMonitoringClick(): void {
        // @ts-ignore
        window.open(this.geneticMonitoringUrl, '_blank').focus();
        this.startOrderOverlay()?.toggle(false);
    }

    handleMicrobiomeClick(): void {
        // @ts-ignore
        window.open(this.microbiomeUrl, '_blank').focus();
        this.startOrderOverlay()?.toggle(false);
    }
}
